import React from 'react';
import Link from 'gatsby-link';
import Slider from "react-slick";
import YouTube from 'react-youtube';
import BicenturyLink from "../link";
import Bicentury_GA from '../../utils/analytics';

const videoOptions = {
	playerVars: {
		rel: 0,
		hd: 1,
		controls: 0,
		modestbranding: 1,
		showinfo: 0
	},
	host: 'https://www.youtube-nocookie.com'
}

const getYoutubeVideoIdFromURL = function(url){
	return url.substring(url.lastIndexOf('/') + 1);
}

const getYoutubeURLFromVideoId = function(id){
	if(id.lastIndexOf('embed') == -1){
		return `https://www.youtube-nocookie.com/embed/${id}`;
	}
	else{
		return id;
	}
}

/**
 * Arrow next
 */
function SampleNextArrow(props) {
	const {className, style, onClick} = props;
	return (
		<div
			className={className}
			style={{...style}}
			onClick={onClick}
		>&gt;&gt;</div>
	);
}

/**
 * Arrow prev
 */
function SamplePrevArrow(props) {
	const {className, style, onClick} = props;
	return (
		<div
			className={className}
			style={{...style}}
			onClick={onClick}
		>&lt;&lt;</div>
	);
}

/**
 * Mapping items
 */

const sliderItems = (item, idx) => {
	let classAnimation = (item.animation) ? 'content slideAnimated' : 'content';
	let classAnimationMobile = `${classAnimation} with-mobile`;
	if (item.mobile_image && "undefined" != typeof(item.mobile_image) && "null" != item.mobile_image) {
		classAnimation = `${classAnimation} with-desktop`;
	} else {
		classAnimationMobile = "hidden-item";
	}

	const handlePlay = function(){
		const url = getYoutubeURLFromVideoId(item.linkToVideo);
		Bicentury_GA.sendEvent('Video', 'click', url);
	}

	const putTitleImage = (item) => {
		if (item.title_image && "undefined" != typeof(item.title_image) && "null" != item.title_image) {
			return (<img className="title-image" src={`/${item.title_image}`}></img>)
		}
		return (<div></div>)
	}

	const putTitleBody = (item) => {
		if (item.title && "undefined" != typeof(item.title) && "" != item.title) {
			return (<h2 className="white unicSize">{item.title}</h2>);
		}
	}

	return (
		<div className="item" key={idx}>
			{ item.linkToVideo!=null && item.linkToVideo.trim()!='' ?
					<div className="content content-youtube">
				      <YouTube
				        videoId={getYoutubeVideoIdFromURL(item.linkToVideo)}
				        opts={videoOptions}
				        onPlay={handlePlay}
				      />
					</div>
				:
					<div>
							<div className={classAnimationMobile} style={{background: `url(/${item.mobile_image})`}}>
								<div className="text-container">
									{putTitleImage(item)}
									{putTitleBody(item)}
									<p className="white">{item.text}</p>
									<BicenturyLink className="btn" text={item.linktext} link={item.link} type={item.linktype} lang={item.lang} />
								</div>
							</div>
							<div className={classAnimation} style={{background: `url(/${item.image})`}}>
								<div className="text-container">
									{putTitleImage(item)}
									{putTitleBody(item)}
									<p className="white">{item.text}</p>
									<BicenturyLink className="btn" text={item.linktext} link={item.link} type={item.linktype} />
								</div>
							</div>

					</div>

			}
		</div>
	)
};

const PrincipalSlider = ({data}) => {

	/**
	 * Slider options
	 */
	const settings = {
		dots: true,
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,
		nextArrow: <SampleNextArrow/>,
		prevArrow: <SamplePrevArrow/>,
		appendDots: dots => (
			<div className="dots">
				<ul className="dot"> {dots} </ul>
			</div>
		),
		customPaging: i => (
			<div className="dot-interior"/>
		),
		autoplay: false,
		autoplayspeed: 3000
	};

	return (
		<section className="principal-slider">
			<div className="container-fluid">
				<div className="row">
					<Slider {...settings} className="principal-carousel owl-carousel">
						{ data.map(sliderItems) }
					</Slider>
				</div>
			</div>
		</section>
	)
};

export default PrincipalSlider;



// WEBPACK FOOTER //
// ./src/components/principal-slider/index.js